<template>
  <div class="vuse-content-wrapper">
    <div v-if="hasAccess('report')">
    <vuse-section-definition
      :title="page"
      icon="mdi-file-chart"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row v-show="hasAccess('report.view')">
        <v-col cols="12">
          <v-card>
            <v-tabs v-model="tab" grow>
              <v-tab> Production Report </v-tab>
              <v-tab> Timeclock Report </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <!-- Production Report -->
              <v-tab-item>
                <v-row>
                  <v-col>
                    <v-form
                      @submit.prevent="generateProd()"
                    >
                      <v-card>
                        <v-card-title> Production Report </v-card-title>
                        <v-card-text>
                          <v-expansion-panels multiple v-model="expandedProd">
                            <v-expansion-panel>
                              <v-expansion-panel-header>
                                INPUT
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-row>
                                  <v-col cols="12">
                                    <v-card>
                                      <v-card-text>
                                        <alert-message></alert-message>
                                        <v-row>
                                          <v-col cols="12" sm="12" md="12">
                                            <DateRangePicker
                                              solo
                                              v-model="formProd.dateRange"
                                              hide-details
                                            />
                                          </v-col>

                                          <v-col cols="12" sm="12" md="12">
                                            <jobs-select
                                              v-model="formProd.jobs"
                                              label="Enter jobs you want to find"
                                              multiple
                                              chip
                                              @watchObject="watchJobsProd"
                                            />
                                          </v-col>

                                          <v-col cols="12" sm="12" md="12">
                                            <user-select
                                              v-model="formProd.users"
                                              label="Select Users"
                                              multiple
                                              chip
                                              @watchObject="watchUsersProd"
                                            />
                                          </v-col>

                                          <v-col cols="12" sm="12" md="12">
                                            <v-combobox
                                              v-model="formProd.materials"
                                              label="Materials"
                                              multiple
                                              small-chips
                                              hint="Press enter to add multiple materials"
                                            />
                                          </v-col>
                                        </v-row>
                                      </v-card-text>

                                      <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          type="submit"
                                          color="info"
                                          :loading="loadingProdGenerate"
                                        >
                                          Generate
                                        </v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                              <v-expansion-panel-header>
                                ANALYTICS
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-row>
                                  <v-col cols="12">
                                    <div class="text-subtitle-1">Filters: </div>
                                    <div class="ml-2" v-if="prodParams.dateRange">
                                      <span class="text-subtitle-1">Date Range:</span>
                                      {{ prodParams.dateRange }}
                                    </div>
                                    <div
                                      class="ml-2"
                                      v-if="prodParams.jobs && prodParams.jobs.length > 0"
                                    >
                                      <span class="text-subtitle-1">Jobs: </span>
                                      <v-chip
                                        v-for="(job, idx) in prodParams.jobs"
                                        :key="`${idx}`"
                                        outlined
                                        class="mx-1 mb-1"
                                      >
                                        {{ job }}
                                      </v-chip>
                                    </div>
                                    <div
                                      class="ml-2"
                                      v-if="prodParams.users && prodParams.users.length > 0"
                                    >
                                      <span class="text-subtitle-1">Users: </span>
                                      <v-chip
                                        v-for="(user, idx) in prodParams.users"
                                        :key="`${idx}`"
                                        outlined
                                        class="mx-1 mb-1"
                                      >
                                        {{ user }}
                                      </v-chip>
                                    </div>
                                    <div
                                      class="ml-2"
                                      v-if="prodParams.materials && prodParams.materials.length > 0"
                                    >
                                      <span class="text-subtitle-1">Materials: </span>
                                      <v-chip
                                        v-for="(material, idx) in prodParams.materials"
                                        :key="`${idx}`"
                                        outlined
                                        class="mx-1 mb-1"
                                      >
                                        {{ material }}
                                      </v-chip>
                                    </div>
                                  </v-col>
                                  <v-col cols="12" v-if="hasProdAnalytics">
                                    <v-btn
                                      type="button"
                                      color="info"
                                      :loading="loadingProdExportAnalytics"
                                      @click="exportProdAnalytics()"
                                    >
                                      Export CSV
                                    </v-btn>
                                  </v-col>
                                  <v-col cols="12">
                                    <div v-if="hasProdAnalytics" class="mt-4">
                                      <div class="text-subtitle-1">
                                        Found {{ analyticsProduction.length }} 
                                        {{ analyticsProduction.length === 1 ? 'row' : 'rows' }}
                                      </div>
                                      <v-data-table
                                        :headers="analyticsProdHeaders"
                                        :items="analyticsProduction"
                                        :items-per-page="-1"
                                        class="elevation-1"
                                        :hide-default-footer="true"
                                      />
                                    </div>
                                    <div v-else class="mt-4">
                                        No data found
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                              <v-expansion-panel-header>
                                DATA
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-row>
                                  <v-col cols="12">
                                    <div class="text-subtitle-1">Filters: </div>
                                    <div class="ml-2" v-if="prodParams.dateRange">
                                      <span class="text-subtitle-1">Date Range:</span>
                                      {{ prodParams.dateRange }}
                                    </div>
                                    <div
                                      class="ml-2"
                                      v-if="prodParams.jobs && prodParams.jobs.length > 0"
                                    >
                                      <span class="text-subtitle-1">Jobs: </span>
                                      <v-chip
                                        v-for="(job, idx) in prodParams.jobs"
                                        :key="`${idx}`"
                                        outlined
                                        class="mx-1 mb-1"
                                      >
                                        {{ job }}
                                      </v-chip>
                                    </div>
                                    <div
                                      class="ml-2"
                                      v-if="prodParams.users && prodParams.users.length > 0"
                                    >
                                      <span class="text-subtitle-1">Users: </span>
                                      <v-chip
                                        v-for="(user, idx) in prodParams.users"
                                        :key="`${idx}`"
                                        outlined
                                        class="mx-1 mb-1"
                                      >
                                        {{ user }}
                                      </v-chip>
                                    </div>
                                    <div
                                      class="ml-2"
                                      v-if="prodParams.materials && prodParams.materials.length > 0"
                                    >
                                      <span class="text-subtitle-1">Materials: </span>
                                      <v-chip
                                        v-for="(material, idx) in prodParams.materials"
                                        :key="`${idx}`"
                                        outlined
                                        class="mx-1 mb-1"
                                      >
                                        {{ material }}
                                      </v-chip>
                                    </div>
                                  </v-col>
                                  <v-col cols="12" v-if="hasProdData">
                                    <v-btn
                                      type="button"
                                      color="info"
                                      :loading="loadingProdExportData"
                                      @click="exportProdData()"
                                    >
                                      Export CSV
                                    </v-btn>
                                  </v-col>
                                  <v-col cols="12">
                                    <div v-if="hasProdData" class="mt-4">
                                      <div class="text-subtitle-1">
                                        Found {{ dataItemProduction.length }} 
                                        {{ dataItemProduction.length === 1 ? 'row' : 'rows' }}
                                      </div>
                                      <v-data-table
                                        :headers="activeProdHeaders"
                                        :items="dataItemProduction"
                                        :items-per-page="-1"
                                        class="elevation-1"
                                        :hide-default-footer="true"
                                      />
                                    </div>
                                    <div v-else class="mt-4">
                                        No data found
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </v-card-text>
                      </v-card>
                    </v-form>
                  </v-col>
                </v-row>
              </v-tab-item>

              <!-- Timeclock Report -->
              <v-tab-item>
                <v-row>
                  <v-col>
                    <v-form
                      @submit.prevent="generateTimeclock()"
                    >
                      <v-card>
                        <v-card-title> Timeclock Report </v-card-title>
                        <v-card-text>
                          <v-expansion-panels multiple v-model="expandedTimeclock">
                            <v-expansion-panel>
                              <v-expansion-panel-header>
                                INPUT
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-row>
                                  <v-col cols="12">
                                    <v-card>
                                      <v-card-text>
                                        <alert-message></alert-message>
                                        <v-row>
                                          <v-col cols="12" sm="12" md="12">
                                            <DateRangePicker
                                              solo
                                              v-model="formTimeclock.dateRange"
                                              hide-details
                                            />
                                          </v-col>

                                          <v-col cols="12" sm="12" md="12">
                                            <jobs-select
                                              v-model="formTimeclock.jobs"
                                              label="Enter jobs you want to find"
                                              multiple
                                              chip
                                              @watchObject="watchJobsTimeclock"
                                            />
                                          </v-col>

                                          <v-col cols="12" sm="12" md="12">
                                            <user-select
                                              v-model="formTimeclock.users"
                                              label="Select Users"
                                              multiple
                                              chip
                                              @watchObject="watchUsersTimeclock"
                                            />
                                          </v-col>
                                        </v-row>
                                      </v-card-text>

                                      <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          type="submit"
                                          color="info"
                                          :loading="loadingTimeclockGenerate"
                                        >
                                          Generate
                                        </v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                              <v-expansion-panel-header>
                                ANALYTICS
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-row>
                                  <v-col cols="12">
                                    <div class="text-subtitle-1">Filters: </div>
                                    <div class="ml-2" v-if="timeclockParams.dateRange">
                                      <span class="text-subtitle-1">Date Range:</span>
                                      {{ timeclockParams.dateRange }}
                                    </div>
                                    <div
                                      class="ml-2"
                                      v-if="timeclockParams.jobs && timeclockParams.jobs.length > 0"
                                    >
                                      <span class="text-subtitle-1">Jobs: </span>
                                      <v-chip
                                        v-for="(job, idx) in timeclockParams.jobs"
                                        :key="`${idx}`"
                                        outlined
                                        class="mx-1 mb-1"
                                      >
                                        {{ job }}
                                      </v-chip>
                                    </div>
                                    <div
                                      class="ml-2"
                                      v-if="timeclockParams.users && timeclockParams.users.length > 0"
                                    >
                                      <span class="text-subtitle-1">Users: </span>
                                      <v-chip
                                        v-for="(user, idx) in timeclockParams.users"
                                        :key="`${idx}`"
                                        outlined
                                        class="mx-1 mb-1"
                                      >
                                        {{ user }}
                                      </v-chip>
                                    </div>
                                  </v-col>
                                  <v-col cols="12" v-if="hasTimeclockAnalytics">
                                    <v-btn
                                      type="button"
                                      color="info"
                                      :loading="loadingTimeclockExportAnalytics"
                                      @click="exportTimeclockAnalytics()"
                                    >
                                      Export CSV
                                    </v-btn>
                                  </v-col>
                                  <v-col cols="12">
                                    <div v-if="hasTimeclockAnalytics" class="mt-4">
                                      <div class="text-subtitle-1">
                                        Found {{ analyticsTimeclock.length }} 
                                        {{ analyticsTimeclock.length === 1 ? 'row' : 'rows' }}
                                      </div>
                                      <v-data-table
                                        :headers="analyticsTimeclockHeaders"
                                        :items="analyticsTimeclock"
                                        :items-per-page="-1"
                                        class="elevation-1"
                                        :hide-default-footer="true"
                                      />
                                    </div>
                                    <div v-else class="mt-4">
                                        No data found
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                              <v-expansion-panel-header>
                                DATA
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-row>
                                  <v-col cols="12">
                                    <div class="text-subtitle-1">Filters: </div>
                                    <div class="ml-2" v-if="timeclockParams.dateRange">
                                      <span class="text-subtitle-1">Date Range:</span>
                                      {{ timeclockParams.dateRange }}
                                    </div>
                                    <div
                                      class="ml-2"
                                      v-if="timeclockParams.jobs && timeclockParams.jobs.length > 0"
                                    >
                                      <span class="text-subtitle-1">Jobs: </span>
                                      <v-chip
                                        v-for="(job, idx) in timeclockParams.jobs"
                                        :key="`${idx}`"
                                        outlined
                                        class="mx-1 mb-1"
                                      >
                                        {{ job }}
                                      </v-chip>
                                    </div>
                                    <div
                                      class="ml-2"
                                      v-if="timeclockParams.users && timeclockParams.users.length > 0"
                                    >
                                      <span class="text-subtitle-1">Users: </span>
                                      <v-chip
                                        v-for="(user, idx) in timeclockParams.users"
                                        :key="`${idx}`"
                                        outlined
                                        class="mx-1 mb-1"
                                      >
                                        {{ user }}
                                      </v-chip>
                                    </div>
                                  </v-col>
                                  <v-col cols="12" v-if="hasTimeclockData">
                                    <v-btn
                                      type="button"
                                      color="info"
                                      :loading="loadingTimeclockExportData"
                                      @click="exportTimeclockData()"
                                    >
                                      Export CSV
                                    </v-btn>
                                  </v-col>
                                  <v-col cols="12">
                                    <div v-if="hasTimeclockData" class="mt-4">
                                      <div class="text-subtitle-1">
                                        Found {{ dataItemTimeclock.length }} 
                                        {{ dataItemTimeclock.length === 1 ? 'row' : 'rows' }}
                                      </div>
                                      <v-data-table
                                        :headers="activeTimeclockHeaders"
                                        :items="dataItemTimeclock"
                                        :items-per-page="-1"
                                        class="elevation-1"
                                        :hide-default-footer="true"
                                      />
                                    </div>
                                    <div v-else class="mt-4">
                                        No data found
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </v-card-text>
                      </v-card>
                    </v-form>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    </div>
    <NoPermission v-else />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import AlertMessage from "src/components/AlertMessage";
import formatterMixin from "@/mixins/formatterMixin";
import JobsSelect from "components/TaskSelect.vue";
import UserSelect from "components/UserSelect.vue";
import DateRangePicker from "components/DateRangePicker";
import NoPermission from "components/NoPermission";
import moment from "moment-timezone";

export default {
  components: {
    AlertMessage,
    JobsSelect,
    DateRangePicker,
    UserSelect,
    NoPermission
  },
  mixins: [formatterMixin],
  data() {
    return {
      tab: null,
      page: "Reports",

      expandedProd: [0,1,2],
      expandedTimeclock: [0,1,2],

      formProd: {
        dateRange: {},
        jobs: [],
        users: [],
        materials: [],
      },

      formTimeclock: {
        dateRange: {},
        jobs: [],
        users: [],
      },

      prodJobs: [],
      timeclockJobs: [],

      prodUsers: [],
      timeclockUsers: [],

      loadingProdGenerate: false,
      loadingProdExportAnalytics: false,
      loadingProdExportData: false,
      loadingTimeclockGenerate: false,
      loadingTimeclockExportAnalytics: false,
      loadingTimeclockExportData: false,

      prodParams: {
        dateRange: "",
        jobs: [],
        users: [],
        materials: [],
      },
      timeclockParams: {
        dateRange: "",
        jobs: [],
        users: [],
      },

      analyticsProdHeaders: [
        {
          text: "Job Code",
          value: "jobCode",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Job Name",
          value: "jobName",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Change Order",
          value: "changeOrder",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Material",
          value: "material",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Quoted Usage (Footage)",
          value: "quotedUsage",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Actual Usage (Footage)",
          value: "actualUsage",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Footage Unit",
          value: "unit",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Quoted Usage (Material)",
          value: "quotedUsageCase",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Actual Usage (Material)",
          value: "actualUsageCase",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Material Unit",
          value: "case",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Quoted Man Hours",
          value: "quotedHours",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Actual Man Hours",
          value: "actualHours",
          sortable: true,
          readonly: true,
          active: true,
        },
      ],
      
      activeProdHeaders: [
        {
          text: "Job Code",
          value: "jobCode",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Job Name",
          value: "jobName",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Change Order",
          value: "changeOrder",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Material",
          sortable: true,
          value: "material",
          active: true,
        },
        {
          text: "Date",
          value: "date",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "User",
          sortable: true,
          value: "user",
          active: true,
        },
        {
          text: "Amount of Footage",
          sortable: true,
          value: "quantity",
          active: true,
        },
        {
          text: "Footage Unit",
          align: "start",
          sortable: true,
          value: "unit",
          active: true,
        },
        {
          text: "Amount of Material",
          sortable: true,
          value: "quantityPerCase",
          active: true,
        },
        {
          text: "Material Unit",
          sortable: true,
          value: "case",
          active: true,
        },
        {
          text: "Work Time",
          sortable: true,
          value: "workTime",
          active: true,
        },
      ],

      analyticsTimeclockHeaders: [
        {
          text: "User",
          sortable: true,
          value: "user",
          active: true,
        },
        {
          text: "Job Code",
          value: "jobCode",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Job Name",
          value: "jobName",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Change Order",
          value: "changeOrder",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Material",
          sortable: true,
          value: "material",
          active: true,
        },
        {
          text: "Amount of Footage",
          sortable: true,
          value: "quantity",
          active: true,
        },
        {
          text: "Footage Unit",
          sortable: true,
          value: "unit",
          active: true,
        },
        {
          text: "Amount of Material",
          sortable: true,
          value: "quantityPerCase",
          active: true,
        },
        {
          text: "Material Unit",
          sortable: true,
          value: "case",
          active: true,
        },
        {
          text: "Total Work Time",
          sortable: true,
          value: "totalWorkTime",
          active: true,
        },
      ],

      activeTimeclockHeaders: [
        {
          text: "User",
          sortable: true,
          value: "user",
          active: true,
        },
        {
          text: "Job Code",
          value: "jobCode",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Job Name",
          value: "jobName",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Change Order",
          value: "changeOrder",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Material",
          value: "material",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Amount of Footage",
          value: "quantity",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Footage Unit",
          value: "unit",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Amount of Material",
          value: "quantityPerCase",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Material Unit",
          value: "case",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Date",
          value: "date",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Start",
          value: "startTime",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "End",
          value: "endTime",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Out Time",
          value: "outTime",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Work Time",
          value: "workTime",
          sortable: true,
          readonly: true,
          active: true,
        },
        {
          text: "Notes",
          value: "notes",
          sortable: true,
          readonly: true,
          active: true,
        },
      ],

      valid: false,
    };
  },

  computed: {
    ...mapGetters("account", ["hasAccess"]),
    ...mapState({
      account: (state) => state.account,
      timeclock: (state) => state.timeclock,
      alert: (state) => state.alert
    }),

    hasProdData() {
      return this.dataItemProduction && this.dataItemProduction.length > 0;
    },

    hasProdAnalytics() {
      return this.analyticsProduction && this.analyticsProduction.length > 0;
    },

    hasTimeclockData() {
      return this.dataItemTimeclock && this.dataItemTimeclock.length > 0;
    },

    hasTimeclockAnalytics() {
      return this.analyticsTimeclock && this.analyticsTimeclock.length > 0;
    },

    analyticsProduction() {
      return this.timeclock.dataProd.analytics;
    },

    analyticsTimeclock() {
      return this.timeclock.dataTimeclock.analytics;
    },

    dataItemProduction() {
      return this.timeclock.dataProd.data;
    },

    dataItemTimeclock() {
      return this.timeclock.dataTimeclock.data;
    },
  },
  created() {
    this.formProd.dateRange.start = this.momentLocal().format("YYYY-MM-DD");
    this.formProd.dateRange.end = this.momentLocal().format("YYYY-MM-DD");
    this.formTimeclock.dateRange.start = this.momentLocal().format("YYYY-MM-DD");
    this.formTimeclock.dateRange.end = this.momentLocal().format("YYYY-MM-DD");
  },

  methods: {
    ...mapActions({      
      reportExportProdAnalytics: "timeclock/reportExportProdAnalytics",
      reportExportProdData: "timeclock/reportExportProdData",
      reportJsonProd: "timeclock/reportJsonProd",
      reportExportTimeclockAnalytics: "timeclock/reportExportTimeclockAnalytics",
      reportExportTimeclockData: "timeclock/reportExportTimeclockData",
      reportJsonTimeclock: "timeclock/reportJsonTimeclock",
    }),

     watchJobsProd(jobs) {
      this.prodJobs = jobs;
    },

    watchUsersProd(users) {
      this.prodUsers = users;
    },

    watchJobsTimeclock(jobs) {
      this.timeclockJobs = jobs;
    },

    watchUsersTimeclock(users) {
      this.timeclockUsers = users;
    },

    async exportProdAnalytics() {
      const { start, end } = this.formProd.dateRange;
      let payload = {
        ...this.formProd,
      };

      delete payload.dateRange
      if (start) {
        payload.startDate = this.moment(start).format('YYYY-MM-DD[T]HH:mm:ss');
      }
      if (end) {
        payload.endDate = this.moment(end).add(1,'day').format('YYYY-MM-DD[T]HH:mm:ss');
      }

      payload.timeZoneOffset = Math.floor(this.moment().utcOffset() / 60);

      this.loadingProdExportAnalytics = true;
      await this.reportExportProdAnalytics(payload);
      this.loadingProdExportAnalytics = false;
    },

    async exportProdData() {
      const { start, end } = this.formProd.dateRange;
      let payload = {
        ...this.formProd,
      };

      delete payload.dateRange
      if (start) {
        payload.startDate = this.moment(start).format('YYYY-MM-DD[T]HH:mm:ss');
      }
      if (end) {
        payload.endDate = this.moment(end).add(1,'day').format('YYYY-MM-DD[T]HH:mm:ss');
      }

      payload.timeZoneOffset = Math.floor(this.moment().utcOffset() / 60);

      this.loadingProdExportData = true;
      await this.reportExportProdData(payload);
      this.loadingProdExportData = false;
    },

    async generateProd() {
      const { start, end } = this.formProd.dateRange;
      let payload = {
        ...this.formProd,
      };
      
      delete payload.dateRange
      if (start) {
        payload.startDate = this.moment(start).format('YYYY-MM-DD[T]HH:mm:ss');
      }
      if (end) {
        payload.endDate = this.moment(end).add(1,'day').format('YYYY-MM-DD[T]HH:mm:ss');
      }

      payload.timeZoneOffset = Math.floor(this.moment().utcOffset() / 60);

      this.loadingProdGenerate = true;
      await this.reportJsonProd(payload);
      this.setProdParams();
      this.loadingProdGenerate = false;
    },

    // prepares data for generated report filter summaries
    setProdParams() {
      const { start, end } = this.formProd.dateRange;

      const ISO_FORMAT = "MM-DD-yyyy";
      if(start && end) {
        this.prodParams.dateRange = moment(start).format(ISO_FORMAT);
        this.prodParams.dateRange += " To "
        this.prodParams.dateRange += moment(end).format(ISO_FORMAT);
      } else if(start) {
        this.prodParams.dateRange = "From " + moment(start).format(ISO_FORMAT);
      } else if(end) {
        this.prodParams.dateRange = "To " + moment(end).format(ISO_FORMAT);
      } else {
        this.prodParams.dateRange = ""
      }

      if(this.prodJobs && this.prodJobs.length > 0) {
        const jobs = this.prodJobs.map(i => i.name + ` (${i.code} - ${i.type})`);
        this.prodParams.jobs = jobs;
      } else {
        this.prodParams.jobs = [];
      }

      if(this.prodUsers && this.prodUsers.length > 0) {
        const users = this.prodUsers.map(i => `${i.firstName} ${i.lastName}`);
        this.prodParams.users = users;
      } else {
        this.prodParams.users = [];
      }

      if(this.formProd.materials && this.formProd.materials.length > 0) {
        this.prodParams.materials = this.formProd.materials;
      } else {
        this.prodParams.materials = [];
      }
    },

    async exportTimeclockAnalytics() {
      const { start, end } = this.formTimeclock.dateRange;
      let payload = {
        ...this.formTimeclock,
      };

      delete payload.dateRange
      if (start) {
        payload.startDate = this.moment(start).format('YYYY-MM-DD[T]HH:mm:ss');
      }
      if (end) {
        payload.endDate = this.moment(end).add(1,'day').format('YYYY-MM-DD[T]HH:mm:ss');
      }

      payload.timeZoneOffset = Math.floor(this.moment().utcOffset() / 60);

      this.loadingTimeclockExportAnalytics = true;
      await this.reportExportTimeclockAnalytics(payload);
      this.loadingTimeclockExportAnalytics = false;
    },

    async exportTimeclockData() {
      const { start, end } = this.formTimeclock.dateRange;
      let payload = {
        ...this.formTimeclock,
      };

      delete payload.dateRange
      if (start) {
        payload.startDate = this.moment(start).format('YYYY-MM-DD[T]HH:mm:ss');
      }
      if (end) {
        payload.endDate = this.moment(end).add(1,'day').format('YYYY-MM-DD[T]HH:mm:ss');
      }

      payload.timeZoneOffset = Math.floor(this.moment().utcOffset() / 60);

      this.loadingTimeclockExportData = true;
      await this.reportExportTimeclockData(payload);
      this.loadingTimeclockExportData = false;
    },

    async generateTimeclock() {
      const { start, end } = this.formTimeclock.dateRange;
      let payload = {
        ...this.formTimeclock,
      };
      
      delete payload.dateRange
      if (start) {
        payload.startDate = this.moment(start).format('YYYY-MM-DD[T]HH:mm:ss');
      }
      if (end) {
        payload.endDate = this.moment(end).add(1,'day').format('YYYY-MM-DD[T]HH:mm:ss');
      }

      payload.timeZoneOffset = Math.floor(this.moment().utcOffset() / 60);

      this.loadingTimeclockGenerate = true;
      await this.reportJsonTimeclock(payload);
      this.setTimeclockParams();
      this.loadingTimeclockGenerate = false;
    },

    // prepares data for generated report filter summaries
    setTimeclockParams() {
      const { start, end } = this.formTimeclock.dateRange;

      const ISO_FORMAT = "MM-DD-yyyy";
      if(start && end) {
        this.timeclockParams.dateRange = moment(start).format(ISO_FORMAT);
        this.timeclockParams.dateRange += " To "
        this.timeclockParams.dateRange += moment(end).format(ISO_FORMAT);
      } else if(start) {
        this.timeclockParams.dateRange = "From " + moment(start).format(ISO_FORMAT);
      } else if(end) {
        this.timeclockParams.dateRange = "To " + moment(end).format(ISO_FORMAT);
      } else {
        this.timeclockParams.dateRange = ""
      }

      if(this.timeclockJobs && this.timeclockJobs.length > 0) {
        const jobs = this.timeclockJobs.map(i => i.name + ` (${i.code} - ${i.type})`);
        this.timeclockParams.jobs = jobs;
      } else {
        this.timeclockParams.jobs = [];
      }

      if(this.timeclockUsers && this.timeclockUsers.length > 0) {
        const users = this.timeclockUsers.map(i => `${i.firstName} ${i.lastName}`);
        this.timeclockParams.users = users;
      } else {
        this.timeclockParams.users = [];
      }
    },
  },
};
</script>